import { Component, Injector, OnInit } from '@angular/core';

import { UserService } from 'src/app/service/UserService';
import { BaseComponent } from '../../common/BaseComponent';
import { User } from 'src/app/model/user';

@Component({
  selector: 'app-role-management',
  templateUrl: './role-management.component.html'
})
export class RoleManagementComponent extends BaseComponent implements OnInit {
  roles: any;
  user: User;

  constructor(
    injector: Injector,
    public rest: UserService
  ) {
    super(injector);
  }

  ngOnInit(): void {

    this.rest.getUserRoles(this.user).subscribe(response => {
      console.log("send-email:" + JSON.stringify(response));
      if (response['result'] > 0) {
        this.appError = true;
        //this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
      } else {
        this.appError = false;
        this.roles = response['enrolledroles'];
      }
    }, (error) => { this.processError(error) });
  }

  viewProfile() : void {
    this.router.navigate(['secure/profile']);
  }
}
